// extracted by mini-css-extract-plugin
export default {"confirm_wrapper":"ConfirmPage_confirm_wrapper__0NDjK","answer_wrapper":"ConfirmPage_answer_wrapper__LXEKo"};